import { useState } from 'react'
import { Navigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'

import { PageHeader } from '~/components/PageHeader'
import Tabs from '~/components/Tabs'
import Tile from '~/components/Tile'
import { isLockDateExpired } from '~/lib/isLockDateExpired'

import { IncreaseUnlockTime } from './IncreaseUnlockTime'
import { IncreaseAmount } from './IncreaseAmount'
import { useLockChangeDetails } from './useLockChangeDetails'
import { useVESISParams } from '~/hooks/useVESISParams'

type Tab = 'amount' | 'date'

export function LockSettingsPage() {
	const { config } = useVESISParams()

	const { data, isFetched } = useLockChangeDetails()

	const [tab, setTab] = useState<Tab>('amount')

	const isUnlock = data && isLockDateExpired(data.end.toNumber())

	if ((isFetched && !data) || isUnlock) {
		return <Navigate to={`/vesis/${config.slug}`} />
	}

	return (
		<Tile>
			<Helmet>
				<title>Lock Settings</title>
			</Helmet>

			<Tile.Header>
				<PageHeader
					title="Lock Settings"
					backLink={`/vesis/${config.slug}`}
					onQuestionClick={() => {
						window.open(
							'https://docs.symbiosis.finance/liquidity-providers/vesis',
							'_blank'
						)
						// TODO show bubbles
					}}
				/>

				<Tabs
					defaultActive="amount"
					tabs={[
						{
							id: 'amount',
							name: 'Increase Amount',
						},
						{
							id: 'date',
							name: 'Increase Time',
						},
					]}
					onChange={(value) => {
						setTab(value.id as Tab)
					}}
				/>
			</Tile.Header>

			{tab === 'amount' ? (
				<IncreaseAmount locked={data} />
			) : (
				<IncreaseUnlockTime locked={data} />
			)}
		</Tile>
	)
}
